import { Accordion, Typography, AccordionSummary, Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { FC } from 'react';
import { useToggle } from '../../../../../../../../../../../hooks/use-toggle';
import type { ItemOf, Optional } from '@vy/utils';
import { XeroIntegrationStatusAccordionDetails } from './xero-integration-status-accordion-components/XeroIntegrationStatusAccordionDetails';
import type { GetLightInvoicesResponse, GetExportedIntegrationsResponse } from '@vy/api-definition';
import { SYNC_JOB_STATUSES } from '@vy/integrations-types';

type XeroIntegrationStatusAccordionProps = {
  xeroIntegration: Optional<ItemOf<GetExportedIntegrationsResponse>>;
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
};

export const XeroIntegrationStatusAccordion: FC<XeroIntegrationStatusAccordionProps> = ({
  xeroIntegration,
  invoice,
}) => {
  const [expanded, toggleExpanded] = useToggle(true);
  const isSynced = xeroIntegration?.status === SYNC_JOB_STATUSES.COMPLETED;

  return (
    <Accordion expanded={expanded} onChange={() => toggleExpanded()} sx={{ p: 0 }}>
      <AccordionSummary
        expandIcon={
          <VyIcon
            icon="ArrowDown"
            style={{
              color: '#323232',
            }}
          />
        }
        sx={{ p: 0, height: '34px', alignItems: 'center' }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1
          }}>
          <VyIcon icon="Synchronize" />
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: "24px"
            }}>
            Integration status
          </Typography>

          {isSynced && (
            <div
              style={{
                width: '8px',
                height: '8px',
                backgroundColor: '#65CF7E',
                borderRadius: '50%',
              }}
            />
          )}
        </Stack>
      </AccordionSummary>
      <XeroIntegrationStatusAccordionDetails xeroIntegration={xeroIntegration} invoice={invoice} />
    </Accordion>
  );
};
